<template>
    <div class="progress">
      <div class="banner"></div>
      <div class="profile">
        <div class="profile-header">
          <div class="title">
            <div class="cont_tit">
              <p>平台规范</p>
              <span>Platform Specification</span>
            </div>
            <div class="crumb">
              <span>当前位置：</span>
              <a href="../" target="_self" title="首页" class="CurrChnlCls"
                >首页</a
              >&gt;<a href="" target="_self" title="平台规范" class="CurrChnlCls"
                >平台规范</a
              >&gt;<a target="_self" class="CurrChnlCls">{{
                Mode == 1
                  ? "用户服务协议"
                  : Mode == 2
                  ? "隐私政策"
                  : Mode == 3
                  ? "法律声明"
                  : Mode == 4
                  ? "用人单位招聘规范"
                  :""
              }}</a>
            </div>
          </div>
        </div>
        <div class="profile-conter">
          <ul class="job-tab">
            <li
              v-for="(item, index) in tabs"
              :key="index"
              class="tab-item"
              :class="{ 'item--active': Mode == index + 1 }"
              @click="toggleLoginMode(index + 1)"
            >
              {{ item }}
            </li>
          </ul>
        </div>
        <div class="resumeForm">
          <div v-if="Mode == 1">
            <service-agreement></service-agreement>
          </div>
          <div v-if="Mode == 2">
            <privacy-policy></privacy-policy>
          </div>
          <div v-if="Mode == 3">
            <legal-statement></legal-statement>
          </div>
          <div v-if="Mode == 4">
            <recruitment-norms></recruitment-norms>
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
  export default {
    name: "platformSpecification",
    data() {
      return {
        Mode: "",
        tabs: ["用户服务协议", "隐私政策", "法律声明", "用人单位招聘规范"]
      };
    },
    watch: {
      //监听路由地址的改变
      $route: {
        immediate: true,
        handler() {
          if (this.$route.query.platformSpecificationId) {
            //需要监听的参数
            this.Mode = this.$route.query.platformSpecificationId;
          }
        }
      },
      Mode(newVal) {
        this.updateRouteParams(newVal);
      },
    },
    methods: {
      toggleLoginMode(mode) {
        this.Mode = mode;
      },
      updateRouteParams(query) {
        if (query) {
          this.$router.push({
            path: "/platformSpecification",
            query: { platformSpecificationId: query },
          });
        } else {
          this.$router.push({
            path: "/platformSpecification",
            query: { platformSpecificationId: "1" },
          });
        }
        location.reload();
      },
    }
  };
  </script>
  <style lang="less" scoped>
  .banner {
    background-image: url("../assets/images/jrwmpc.png");
    background-size: 100% 100%;
    padding-bottom: 32%;
    background-repeat: no-repeat;
  }
  .profile {
    width: @main-width;
    margin: auto;
    &-header {
      padding-top: 50px;
      margin-bottom: 50px;
      .title {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
  
      .cont_tit {
        position: relative;
        font-weight: 800;
      }
  
      .cont_tit:after {
        content: "";
        position: absolute;
        background: url("../assets/images/index20231114_8.png") center center
          no-repeat;
        background-size: 100% auto;
        width: 450px;
        height: 56px;
        left: -10px;
        bottom: -30px;
      }
  
      .cont_tit p {
        display: inline-block;
        font-size: 30px;
        padding-right: 20px;
        line-height: 1.1;
        position: relative;
        margin-right: 20px;
        font-weight: 600;
        color: #335593;
      }
  
      .cont_tit p:after {
        content: "";
        position: absolute;
        height: 28px;
        width: 3px;
        left: 100%;
        bottom: 0;
        background: #7499ce;
      }
  
      .cont_tit span {
        display: inline-block;
        font-size: 14px;
        color: #b1b1b1;
      }
  
      .title .crumb {
        color: #585858;
        font-size: 18px;
      }
  
      .title .crumb a {
        margin: 0 10px;
        display: inline-block;
      }
    }
    &-conter {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 20px;
      .job-tab {
        align-items: center;
        border-bottom: 1px solid #7499ce;
        display: -ms-flexbox;
        display: flex;
        height: 62px;
        justify-content: space-around;
        line-height: 62px;
        margin-bottom: 10px;
        width: 100%;
        .tab-item {
          cursor: pointer;
          display: block;
          font-size: 18px;
          font-weight: 500;
          height: 62px;
          line-height: 62px;
          position: relative;
        }
        .tab-item.item--active {
          color: #7499ce;
          font-weight: bold;
        }
        .tab-item.item--active:after {
          content: "";
          position: absolute;
          width: 18px;
          height: 18px;
          border-color: #7499ce #7499ce #fff #fff;
          border-style: solid;
          border-width: 1px;
          top: calc(100% - 0.49em);
          left: 50%;
          background: #fff;
          transform: rotate(-45deg) translateX(-50%) translateY(-50%);
        }
      }
    }
    .resumeForm {
      margin: 20px 0;
      background: #fff;
      box-shadow: 0px 9px 20px 0px #c2c1c180;
      border-radius: 4px;
      padding: 30px;
    }
  }
  </style>
  